module.exports = __webpack_public_path__ + "img/developers-icon.71e4d39b.svg";